import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Plus, Edit3, Trash2, X, Save, Upload, RefreshCw } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL || '';

const ArtistModalFull = ({ artist, onClose, onSave }) => {
  const [form, setForm] = useState(artist || {
    name: '', image: '', spotify_url: '', youtube_url: '', genre: '', tag: '', is_featured: true, order: 0
  });
  const [saving, setSaving] = useState(false);
  const [uploading, setUploading] = useState(false);

  const handleUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setUploading(true);
    try {
      const fd = new FormData();
      fd.append('file', file);
      const r = await axios.post(`${API}/api/admin/upload/images`, fd, {
        withCredentials: true, headers: { 'Content-Type': 'multipart/form-data' }
      });
      setForm({ ...form, image: r.data.url });
    } catch { alert('Error subiendo imagen'); }
    setUploading(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.name.trim()) { alert('Nombre del artista requerido'); return; }
    setSaving(true);
    try { await onSave({ ...form, order: parseInt(form.order) || 0 }); }
    catch { alert('Error guardando'); }
    setSaving(false);
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 p-4" onClick={e => { if (e.target === e.currentTarget) onClose(); }}>
      <div className="glass-card p-6 w-full max-w-lg max-h-[90vh] overflow-y-auto" data-testid="artist-modal-full">
        <div className="flex items-center justify-between mb-6">
          <h3 className="text-lg font-bold">{artist ? 'Editar Artista' : 'Agregar Artista'}</h3>
          <button onClick={onClose} className="p-1 rounded-lg hover:bg-white/10"><X className="w-5 h-5" /></button>
        </div>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-xs text-white/50 mb-1">Imagen del Artista</label>
            <div className="flex gap-2">
              <input className="flex-1 input-glass text-sm" value={form.image} onChange={e => setForm({ ...form, image: e.target.value })} placeholder="URL o subir imagen" data-testid="artist-input-image" />
              <label className={`btn-secondary py-2 px-3 text-sm cursor-pointer flex items-center gap-1 ${uploading ? 'opacity-50' : ''}`}>
                <Upload className="w-4 h-4" />{uploading ? '...' : 'Subir'}
                <input type="file" accept="image/*" className="hidden" onChange={handleUpload} disabled={uploading} />
              </label>
            </div>
            {form.image && (
              <div className="flex items-start gap-3 mt-2">
                <img src={form.image} alt="Preview" className="w-16 h-16 object-cover rounded-lg border border-white/10" />
                <button type="button" onClick={() => setForm({ ...form, image: '' })} className="text-xs text-red-400 hover:text-red-300 mt-1">Remover</button>
              </div>
            )}
          </div>
          <div><label className="block text-xs text-white/50 mb-1">Nombre *</label>
            <input className="w-full input-glass" value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} required data-testid="artist-input-name" /></div>
          <div><label className="block text-xs text-white/50 mb-1">Genero</label>
            <input className="w-full input-glass" value={form.genre} onChange={e => setForm({ ...form, genre: e.target.value })} data-testid="artist-input-genre" /></div>
          <div><label className="block text-xs text-white/50 mb-1">Etiqueta / Tag</label>
            <input className="w-full input-glass" value={form.tag || ''} onChange={e => setForm({ ...form, tag: e.target.value })} data-testid="artist-input-tag" /></div>
          <div className="grid grid-cols-2 gap-4">
            <div><label className="block text-xs text-white/50 mb-1">Spotify URL (Artista)</label>
              <input className="w-full input-glass text-sm" value={form.spotify_url || ''} onChange={e => setForm({ ...form, spotify_url: e.target.value })} placeholder="https://open.spotify.com/artist/..." data-testid="artist-input-spotify" /></div>
            <div><label className="block text-xs text-white/50 mb-1">YouTube URL</label>
              <input className="w-full input-glass text-sm" value={form.youtube_url || ''} onChange={e => setForm({ ...form, youtube_url: e.target.value })} placeholder="https://youtube.com/..." data-testid="artist-input-youtube" /></div>
          </div>
          <div><label className="block text-xs text-white/50 mb-1">Spotify Playlist (del Artista)</label>
            <input className="w-full input-glass text-sm" value={form.spotify_playlist_url || ''} onChange={e => setForm({ ...form, spotify_playlist_url: e.target.value })} placeholder="https://open.spotify.com/playlist/..." data-testid="artist-input-spotify-playlist" />
            <p className="text-[10px] text-white/30 mt-1">Playlist curada. Se muestra en el reproductor de la pagina.</p>
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div><label className="block text-xs text-white/50 mb-1">Orden</label>
              <input type="number" className="w-full input-glass" value={form.order} onChange={e => setForm({ ...form, order: e.target.value })} data-testid="artist-input-order" /></div>
            <div><label className="block text-xs text-white/50 mb-1">Destacado</label>
              <button type="button" onClick={() => setForm({ ...form, is_featured: !form.is_featured })}
                className={`w-full py-2.5 rounded-xl text-sm font-medium transition-colors ${form.is_featured ? 'bg-[#E8720C]/20 text-[#E8720C] border border-[#E8720C]/30' : 'bg-white/5 text-white/40 border border-white/10'}`} data-testid="artist-toggle-featured">
                {form.is_featured ? 'Destacado' : 'Oculto'}
              </button>
            </div>
          </div>
          <button type="submit" disabled={saving} className="w-full btn-primary py-3 flex items-center justify-center gap-2" data-testid="artist-form-save">
            <Save className="w-4 h-4" />{saving ? 'Guardando...' : 'Guardar Artista'}
          </button>
        </form>
      </div>
    </div>
  );
};

const ArtistsPanelFull = () => {
  const [artists, setArtists] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modal, setModal] = useState(null);

  const load = async () => {
    try {
      const r = await axios.get(`${API}/api/admin/artists`, { withCredentials: true });
      setArtists(r.data || []);
    } catch (e) { console.error(e); }
    setLoading(false);
  };

  useEffect(() => { load(); }, []);

  const handleSave = async (data) => {
    try {
      if (data.id) {
        await axios.put(`${API}/api/admin/artists/${data.id}`, data, { withCredentials: true });
      } else {
        await axios.post(`${API}/api/admin/artists`, data, { withCredentials: true });
      }
      setModal(null);
      load();
    } catch (err) { alert('Error: ' + (err.response?.data?.detail || err.message)); }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Eliminar este artista?')) return;
    try {
      await axios.delete(`${API}/api/admin/artists/${id}`, { withCredentials: true });
      load();
    } catch { alert('Error eliminando'); }
  };

  if (loading) return <p className="text-white/40">Cargando artistas...</p>;

  const featured = artists.filter(a => a.is_featured);

  return (
    <div data-testid="artists-panel-full">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h2 className="text-2xl font-bold">Artistas ({artists.length})</h2>
          <p className="text-white/50 text-sm">{featured.length} destacados</p>
        </div>
        <button onClick={() => setModal({ type: 'create' })} className="btn-primary py-2 px-5 text-sm" data-testid="add-artist-btn">
          <Plus className="w-4 h-4 inline mr-1" />Agregar Artista
        </button>
      </div>
      <div className="glass-card overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead><tr className="text-left text-white/40 border-b border-white/10">
              <th className="p-4 w-12">#</th><th className="p-4">Imagen</th><th className="p-4">Nombre</th>
              <th className="p-4">Genero</th><th className="p-4">Tag</th><th className="p-4">Destacado</th>
              <th className="p-4">Links</th><th className="p-4">Acciones</th>
            </tr></thead>
            <tbody>
              {artists.map((artist, idx) => (
                <tr key={artist.id} className="border-b border-white/5 hover:bg-white/5">
                  <td className="p-4 text-white/30">{idx + 1}</td>
                  <td className="p-4">
                    {artist.image ? (
                      <img src={artist.image} alt={artist.name} className="w-10 h-10 rounded-lg object-cover border border-white/10" />
                    ) : (
                      <div className="w-10 h-10 rounded-lg bg-[#E8720C]/10 flex items-center justify-center">
                        <span className="text-sm font-bold text-[#E8720C]">{artist.name?.charAt(0)}</span>
                      </div>
                    )}
                  </td>
                  <td className="p-4 font-medium">{artist.name}</td>
                  <td className="p-4 text-white/50">{artist.genre}</td>
                  <td className="p-4 text-white/40 text-xs">{artist.tag}</td>
                  <td className="p-4">
                    <span className={`px-2 py-1 rounded-full text-xs ${artist.is_featured ? 'bg-[#E8720C]/20 text-[#E8720C]' : 'bg-white/5 text-white/30'}`} data-testid={`artist-featured-${artist.id}`}>
                      {artist.is_featured ? 'Destacado' : 'Oculto'}
                    </span>
                  </td>
                  <td className="p-4">
                    <div className="flex items-center gap-1">
                      {artist.spotify_url && <span className="w-2 h-2 rounded-full bg-[#1DB954]" title="Spotify" />}
                      {artist.youtube_url && <span className="w-2 h-2 rounded-full bg-[#FF0000]" title="YouTube" />}
                    </div>
                  </td>
                  <td className="p-4">
                    <div className="flex items-center gap-2">
                      <button onClick={() => setModal({ type: 'edit', data: artist })} className="p-1.5 rounded-lg bg-white/5 hover:bg-white/10 text-white/50 hover:text-white" data-testid={`edit-artist-${artist.id}`}>
                        <Edit3 className="w-3.5 h-3.5" />
                      </button>
                      <button onClick={() => handleDelete(artist.id)} className="p-1.5 rounded-lg bg-red-500/10 hover:bg-red-500/20 text-red-400" data-testid={`delete-artist-${artist.id}`}>
                        <Trash2 className="w-3.5 h-3.5" />
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {artists.length === 0 && <p className="text-center text-white/40 py-8">Sin artistas. Agrega el primero.</p>}
      </div>
      {modal && (
        <ArtistModalFull
          artist={modal.type === 'edit' ? modal.data : null}
          onClose={() => setModal(null)}
          onSave={handleSave}
        />
      )}
    </div>
  );
};

export default ArtistsPanelFull;
